import { useCallback } from 'react';

export const useAddCriteriaHandlers = ({ moveTimeData, onCriteriaChange }) => {
  const handleCriteriaAdd = useCallback(
    type => {
      const newCriterion = {
        id: `${type}-${Date.now()}`,
        type,
        value: null
      };

      onCriteriaChange([...(moveTimeData.criteria || []), newCriterion]);
    },
    [moveTimeData.criteria, onCriteriaChange]
  );

  const handleCriteriaRemove = useCallback(
    criterionId => {
      const updatedCriteria = (moveTimeData.criteria || []).filter(
        c => c.id !== criterionId
      );

      onCriteriaChange(updatedCriteria);
    },
    [moveTimeData.criteria, onCriteriaChange]
  );

  const handleCriterionChange = useCallback(
    updatedCriterion => {
      const updatedCriteria = (moveTimeData.criteria || []).map(c =>
        c.id === updatedCriterion.id ? updatedCriterion : c
      );

      onCriteriaChange(updatedCriteria);
    },
    [moveTimeData.criteria, onCriteriaChange]
  );

  return {
    handleCriteriaAdd,
    handleCriteriaRemove,
    handleCriterionChange
  };
};

export default useAddCriteriaHandlers;
